import request from '@/utils/request'

/**
 * 获取小区设置项列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function listCommunitySettingKey(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communitySettingKey.listCommunitySettingKey',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询小区设置值（按 key 查询单条）
 * @param {Object} params { communityId, settingKey, settingType }
 * @returns {Promise} 返回设置值字符串
 */
export function querySettingValue(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/communitySetting/queryCommunitySetting',
      method: 'get',
      params: {
        communityId: params.communityId,
        settingKey: params.settingKey,
        settingType: params.settingType || '',
        page: 1,
        row: 1
      }
    }).then(response => {
      const res = response.data
      if (res.data && res.data.length > 0) {
        resolve(res.data[0].settingValue || '')
      } else {
        resolve('')
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存小区设置
 * @param {Object} data 保存数据
 * @returns {Promise}
 */
export function saveCommunitySetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.saveCommunitySetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}